import StripeSEPADebitFields from './StripeSEPADebitFields'

export default StripeSEPADebitFields
